import React, { useContext, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

//components
import PageInner from 'components/layout/PageInner'
//contexts
import LoaderContext from 'context/LoaderContext'
import AuthContext from 'context/AuthContext'
//services
import { addSecondEmail } from 'services/userService'

const SecondEmailConnect = () => {
  const { updateUserData } = useContext(AuthContext)
  const { showLoader } = useContext(LoaderContext)

  const { dataId } = useParams()

  const navigate = useNavigate()

  useEffect(() => {
    showLoader()
    addSecondEmail(dataId)
      .then(({ updatedUser, alert }) => {
        updateUserData(updatedUser)
        navigate(`/profile/settings${alert ? '?connectSuccess=connected_email' : ''}`)
      })
      .catch(() => navigate('/profile/settings?connectError=connected_email'))
  }, [])
  return <PageInner />
}

export default SecondEmailConnect
